import styled from 'styled-components';

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0;
  border-top: 1px solid #e5e7eb;
  margin-top: 20px;
`;

export const NavButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: ${(props) => (props.disabled ? '#f3f4f6' : '#5b68df')};
  color: ${(props) => (props.disabled ? '#9ca3af' : '#ffffff')};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover:not(:disabled) {
    background: #4a56c4;
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

export const StepInfo = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
`;
